"use client";

interface MuhuratSummaryBarProps {
  shubhCount: number;
  ashubhCount: number;
  neutralCount: number;
}

export function MuhuratSummaryBar({ shubhCount, ashubhCount, neutralCount }: MuhuratSummaryBarProps) {
  const items = [
    { label: "Shubh", count: shubhCount, color: "bg-green-500" },
    { label: "Ashubh", count: ashubhCount, color: "bg-red-500" },
    { label: "Neutral", count: neutralCount, color: "bg-stone-400" },
  ];

  return (
    <div className="bg-white rounded-2xl border border-ish-border p-4 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 shadow-sm">
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-2.5">
          <span className={`w-2.5 h-2.5 rounded-full ${item.color}`} />
          <span className="text-sm font-medium text-ish-dark">
            <strong className="font-bold">{item.count}</strong> {item.label}
          </span>
        </div>
      ))}
    </div>
  );
}
